<div class="wrap">
  <div class="close-btn">
    <app-svg-icon
      (click)="modalService.dismiss(undefined)"
      name="close"
    ></app-svg-icon>
  </div>
  <div class="icon">
    <app-svg-icon name="add-wallet"></app-svg-icon>
  </div>
  <div class="message">
    {{ "@components.noCreditCardAdded.message" | translate }}
  </div>
  <div class="actions">
    <app-action-button
      (click)="modalService.dismiss(true)"
      [label]="'@components.noCreditCardAdded.actionBtn' | translate"
      [endIconName]="'plus'"
    ></app-action-button>
  </div>
</div>
